<script setup lang="ts">
const {
  averageRating = '',
  reviewCount = '',
  exteriorDesignRating = '',
  interiorDesignRating = '',
  roadAbilityRating = '',
  economicRating = '',
  comfortRating = '',
  equipmentRating = '',
  priceRating = '',
} = defineProps<{
  averageRating?: string
  reviewCount?: string
  exteriorDesignRating?: string
  interiorDesignRating?: string
  roadAbilityRating?: string
  economicRating?: string
  comfortRating?: string
  equipmentRating?: string
  priceRating?: string
}>()
</script>

<template>
  <div class="w-100 all-area">
    <div class="hstack container review-area">
      <div class="comprehensive-evaluation-container">
        <div
          class="d-flex d-flex-shrink align-items-center justify-content-center"
        >
          <div class="comprehensive-evaluation-label">総合評価</div>
        </div>
        <div
          class="d-flex d-flex-shrink align-items-center justify-content-center"
        >
          <div class="comprehensive-evaluation">
            {{ averageRating }}
          </div>
        </div>
        <div class="d-flex d-flex-shrink align-items-center">
          <NuxtRating
            :rating-value="Math.floor(Number(averageRating.toString()))"
            :read-only="true"
            inactive-color="#E7E9ED"
            active-color="#FFDC4A"
            rating-size="15px"
            class="rating"
          />
        </div>
        <div
          class="d-flex d-flex-shrink align-items-center justify-content-center"
        >
          <div class="review-count-text">(投稿数{{ reviewCount }}件)</div>
        </div>
      </div>
      <div class="vr rating-vr" />
      <div class="right-review">
        <table class="table table-borderless w-100">
          <tbody>
            <tr>
              <td class="rating-label-text">外装</td>
              <td class="rating-value-detail">
                {{ exteriorDesignRating }}
              </td>
              <td class="rating-label-text right-table">内装</td>
              <td class="rating-value-detail right-rating">
                {{ interiorDesignRating }}
              </td>
            </tr>
            <tr>
              <td class="rating-label-text">走行性能</td>
              <td class="rating-value-detail">
                {{ roadAbilityRating }}
              </td>
              <td class="rating-label-text right-table">燃費</td>
              <td class="rating-value-detail right-rating">
                {{ economicRating }}
              </td>
            </tr>
            <tr>
              <td class="rating-label-text">乗り心地</td>
              <td class="rating-value-detail">
                {{ comfortRating }}
              </td>
              <td class="rating-label-text right-table">装備</td>
              <td class="rating-value-detail right-rating">
                {{ equipmentRating }}
              </td>
            </tr>
            <tr>
              <td class="rating-label-text">価格</td>
              <td class="rating-value-detail">
                {{ priceRating }}
              </td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.all-area {
  background-color: white;
  padding-top: 16px;
  padding-bottom: 16px;
}

.review-area {
  height: auto;
}

.rating {
  margin-bottom: 8px;
}

.right-review {
  width: 174px;
  max-width: 174px;
  margin-left: 4.3vw;
  display: flex;
  align-items: center;
}

.table {
  margin-bottom: 0 !important;
}

.rating-vr {
  color: #ecf0f2;
  opacity: 100%;
  width: 1px;
  padding-left: 0;
  padding-right: 0;
  z-index: 100;
  min-height: 114px;
  align-items: center;
}

.comprehensive-evaluation-container {
  max-width: 100px;
  margin-left: 6.4vw;
  margin-right: 10.66vw;
}

.comprehensive-evaluation-label {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.comprehensive-evaluation {
  font-size: 40px;
  font-weight: bold;
  color: #df2020;
  height: 53px;
}

.review-count-text {
  font-size: 10px;
}

table tr {
  padding: 0px;
}

td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

td.rating-label-text {
  height: 19px;
  font-size: 12px;
  color: #333333;
  padding-left: 0;
  padding-right: 0;
}

td.rating-value-detail {
  width: 20px;
  height: 19px;
  font-size: 14px;
  font-weight: bold;
  color: #df2020;
  padding-right: 0;
  padding-left: 7px;
  width: 20px;
}

.average-rating::before {
  position: relative;
}

.w-100 {
  height: auto;
}

.right-table {
  text-align: right;
}

.right-rating {
  padding-left: 5.1vw !important;
}
</style>
